import { PhaseEventType } from "@/pages/eaf/data-entry/models/eaf.models";
import { Checkbox } from "@material-ui/core";
import { ColDef } from "ag-grid-enterprise";
import { useCatalogPhaseEventsContext } from "../CatalogPhaseEventsContext";

type Props = {};
export const useTableData = ({}: Props) => {
	const { state } = useCatalogPhaseEventsContext();
	const rows: PhaseEventType[] =
		state.phaseEvents?.map((phaseEvent) => ({
			...phaseEvent,
		})) || [];

	const columns: ColDef[] = [
		{
			field: "EventDescription",
			headerName: "Event Description",
			minWidth: 63,
			flex: 4,
			wrapText: true,
			autoHeight: true,
		},
		{
			field: "IsActive",
			headerName: "Enabled",
			cellRenderer: (params: any) => {
				return <Checkbox checked={params.value} disabled={true} />;
			},
			flex: 4,
			minWidth: 86,
		},
		{
			field: "Actions",
			headerName: "",
			type: ["editButton"],
			flex: 1,
			minWidth: 50,
		},
	];

	return { rows, columns };
};
